import styled from 'styled-components'
import { palette } from '../../../themes/palette'

export const RadioContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const RadioWrapper = styled(RadioContainer)`
  gap: 6px;
`

export const RadioInput = styled.input`
  appearance: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  border: 2px solid ${palette.brand};
  transition: 0.2s all linear;
  top: 4px;

  &:checked {
    border: 6px solid ${palette.brand};
  }
`
